import { parseInteractiveOptionsList } from './parse-interactive-options-list.js'

export function validateInteractiveOptionsList(value: string): string | undefined {
  try {
    parseInteractiveOptionsList(value)
    return undefined
  } catch (error) {
    return error instanceof Error ? error.message : String(error)
  }
}
